import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class fondoFijoService {

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/fondo-fijo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrarDetalle(data) {
        const response = await axios
            .post(`${ERP}tesoreria/fondo-fijo/registrar-detalle`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/fondo-fijo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificarDetalle(data) {
        const response = await axios
            .post(`${ERP}tesoreria/fondo-fijo/actualizar-detalle`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/fondo-fijo/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/fondo-fijo/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}tesoreria/fondo-fijo/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/fondo-fijo/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/fondo-fijo/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/fondo-fijo/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    // async detalles(filter) {
    //     const response = await axios
    //         .get(`${ERP}tesoreria/fondo-fijo/datos-iniciales?${global.formatParameter(filter)}`)
    //         .then(response => {
    //             return response.data;
    //         })
    //         .catch(error => {
    //             console.log(error);
    //         });
    //     return response;
    // };
}

export default new fondoFijoService();